import AbstractView from 'abstracts/AbstractView';
import Screen from "controllers/Screen";


export default class TransitionLines extends AbstractView {
	
	
	constructor( $wrapper ) {
		super();
		this.$wrapper = $wrapper;
		this.doSplit  = this.$wrapper[ 0 ].hasAttribute( 'data-transition-links-split' );
		this.init();
	}
	
	
	initDOM() {
		this.$links = this.$wrapper.find( 'a' );
	}
	
	
	initEl() {
		if ( this.doSplit ) {
			this.split = new SplitText( this.$links, {
				type:       'lines',
				linesClass: 'transition-link-line'
			} );
		} else {
			$( this.$links ).each( ( index, item ) => {
				let itemTextContent = item.textContent
				Array.from( item.children ).forEach(
					itemChild => {
						if ( itemTextContent.includes( itemChild.textContent ) ) {
							itemTextContent = itemTextContent.replace( itemChild.textContent, '' )
						}
					}
				)
				item.setAttribute( 'data-text', itemTextContent );
				this.$links.addClass( 'transition-link-line' );
			} );
		}
		this.$links.addClass( 'transition-link' );
		this.update();
	}
	
	
	update() {
		if ( this.doSplit ) {
			this.split.split();
			$( this.split.lines ).each( ( index, item ) => {
				item.setAttribute( 'data-text', item.textContent );
			} );
		}
	}
	
	
	bindEvents() {
		Screen.on( Screen.E.RESIZE, this.resize, this );
		super.bindEvents();
	}
	
	
	unbindEvents() {
		Screen.off( Screen.E.RESIZE, this.resize, this );
		super.bindEvents();
	}
	
	
	resize( isMobileH ) {
		if ( !isMobileH ) {
			this.update();
		}
	}
	
	
	destroy() {
		this.split = null;
		super.destroy();
	}
}
